import React, {
    ButtonHTMLAttributes,
    ReactNode,
} from "react";

import "./AppButton_New.scss";

export type AppButton_NewVariant =
    | "primary"
    | "secondary"
    | "tertiary";

export interface AppButton_NewProps
    extends Omit<
        ButtonHTMLAttributes<HTMLButtonElement>,
        "children"
    > {
    children: ReactNode;

    variant?: AppButton_NewVariant;

    showArrow?: boolean;
    showBackArrow?: boolean;

    loading?: boolean;

    className?: string;
}

const AppButton_New: React.FC<AppButton_NewProps> = ({
    children,
    variant = "primary",
    showArrow = false,
    showBackArrow = false,
    loading = false,
    disabled = false,
    className = "",
    type = "button",
    ...rest
}) => {
    const isDisabled = disabled || loading;

    return (
        <button
            {...rest}
            type={type}
            disabled={isDisabled}
            className={[
                "app-button-new",
                `app-button-new-${variant}`,
                loading ? "is-loading" : "",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
        >
            {showBackArrow && !loading && (
                <span
                    className="app-button-new-back-icon"
                    aria-hidden="true"
                >
                    ←
                </span>
            )}

            <span className="app-button-new-content">
                {loading ? "Loading..." : children}
            </span>

            {showArrow && !loading && (
                <span
                    className="app-button-new-arrow"
                    aria-hidden="true"
                >
                    ›
                </span>
            )}
        </button>
    );
};

export default AppButton_New;